import common from './common'
import index from './index'
import canvas from './canvas'

document.addEventListener('DOMContentLoaded', function() {
  common()
  index()
  canvas()
});